<template>
  <li>
    <div class="wl-content">
      <img v-if="data.userType=='2'"
           class="img "
           src="src/assets/icons/svg/userlogoClient.svg">
      <img v-if="data.userType=='1'"
           class="img "
           src="src/assets/icons/svg/userlogo.svg">
      <div class="wl-content-container">
        <h3>{{data.commentUser}}</h3>
        <p class="wl-description">{{data.comment}}</p>
        <p class="wl-date">{{data.commentTimeStamp |formatDate}}</p>
      </div>

      <div v-if="showOperation">
        <i class="fa fa-reply wl-icon-reply"
           aria-hidden="true"
           @click="toggleCommentVisible"></i>

        <i :class="iconClass()"
           aria-hidden="true"
           @click="toogleExpand"></i>
      </div>

    </div>
    <ul v-if="hasChild&&expandChild">
      <tree-item v-for="(item, index) in data.children"
                 :data="item"
                 :parent="data"
                 :level="currentLevel"
                 :onAdd="onAdd"
                 :index="index"
                 :key="index"></tree-item>
    </ul>

    <div v-if="showComment"
         class="wl-reply-container">
      <div class="wl-reply-title">
        <span>Reply</span>
        <span>{{data.name}}</span>
      </div>
      <add-comment class="wl-text-area-grey "
                   :onCancel="toggleCommentVisible"
                   :onAdd="onAdd"
                   :pid="data.id"></add-comment>
    </div>

  </li>
</template>

<script>
import AddComment from './add-comment'
import { dateFormat } from '@/utils'

export default {
    name: 'TreeItem',
    data() {
        return {
            showComment: false,
            expandChild: true
        }
    },
    filters: {
        formatDate: value => {
            if (value != null) {
                return dateFormat(new Date(value))
            } else {
                return value
            }
        }
    },
    props: {
        data: {
            type: [Object, Array],
            required: true
        },
        parent: {
            type: [Object, Array]
        },
        level: {
            type: Number,
            default: 0
        },
        onAdd: {
            type: Function,
            required: true
        },
        index: [Number, String]
    },

    computed: {
        hasChild() {
            return this.data.children && this.data.children.length
        },
        currentLevel() {
            const _level = this.level + 1
            return _level
        },
        //不显示树,只显示第一级
        showOperation() {
            // return this.currentLevel === 1;
            return false
        }
    },
    methods: {
        toggleCommentVisible() {
            this.showComment = !this.showComment
        },
        toogleExpand() {
            this.expandChild = !this.expandChild
        },
        iconClass() {
            return this.expandChild ? 'fa fa-minus wl-icon-plus' : 'fa fa-plus wl-icon-plus'
        }
    },
    components: {
        AddComment
    }
}
</script>

<style scoped>
ul {
    list-style: none;
    margin: 0 0 0 70px;
    user-select: none;
}

.wl-reply-container {
    margin: 0 0 0 84px;
}

.wl-reply-container .wl-reply-title {
    padding: 2px 12px;
    color: #a172a9;
}

.wl-reply-title > span:nth-child(2) {
    margin-left: 12px;
}

li {
    padding: 3px 0;
}

h3 {
    font-size: 16px;
    color: #555;
    line-height: 24px;
}

.wl-content {
    position: relative;
    border-top: 1PX solid #eeeeee;
    padding: 12px 0 6px 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
}

.wl-tree-root > li > .wl-content {
    border-top: 0;
}

p.wl-description {
    font-size: 14px;
    color: #555;
    padding: 8px 0;
    word-break: break-all
}

.wl-date {
    font-size: 14px;
    padding: 8px 0;
    color: #aaa;
}

.wl-short-cut {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #fff;
    margin: 12px 24px;
}

.wl-content-container {
    flex: 1;
}

.wl-icon-reply,
.wl-icon-plus {
    position: absolute;
    right: 20px;
    top: 10px;
    font-size: 24px;
    cursor: pointer;
}

.wl-icon-reply {
    right: 60px;
    color: #44b027;
}

.img {
    display: inline-block;
    width: 52px;
    height: 52px;
    margin: 12px 20px;
}
</style>
